import Icon from "../components/Icon";
import type { ClientRow, Identity } from "../types";

export type Tab = "catalog" | "requests" | "history" | "settings";

type SubnavProps = {
  tab: Tab;
  onSetTab: (t: Tab) => void;
  client: ClientRow | null;
  identity: Identity;
  pendingCount?: number;
};

export default function Subnav({
  tab,
  onSetTab,
  client,
  identity,
  pendingCount = 0,
}: SubnavProps) {
  const isPlatformOwner = identity.role === "platform_owner";
  const requestsLabel = isPlatformOwner ? "Change requests" : "My requests";

  const items: { key: Tab; label: string; icon: string }[] = [
    { key: "catalog", label: "Catalog", icon: "list" },
    { key: "requests", label: requestsLabel, icon: "inbox" },
    { key: "history", label: "History", icon: "history" },
    { key: "settings", label: "Settings", icon: "settings" },
  ];

  return (
    <nav className="subnav">
      {items.map((it) => (
        <button
          key={it.key}
          className={`subnav-item${tab === it.key ? " active" : ""}`}
          onClick={() => onSetTab(it.key)}
        >
          <Icon name={it.icon} size={15} />
          <span>{it.label}</span>
          {it.key === "requests" && pendingCount > 0 && (
            <span className="count">{pendingCount}</span>
          )}
        </button>
      ))}
      <span className="subnav-spacer" />
      {client && (
        <span className="subnav-meta">
          <span style={{ color: "var(--accent)" }}>{client.slug}</span>
        </span>
      )}
    </nav>
  );
}
